import { Button, FormField } from '../components/ui';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../api/client';
import { ThemeToggle } from '../context/ThemeContext';
import BrandMark from '../components/BrandMark';

export default function SetupPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSetup = async (e) => {
    e.preventDefault();
    if (!email.trim() || !displayName.trim() || !password) return;
    if (password !== passwordConfirm) {
      setError('Пароли не совпадают.');
      return;
    }
    if (password.length < 6) {
      setError('Пароль должен быть не менее 6 символов.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const user = await api.setupAdmin({
        email: email.trim(),
        display_name: displayName.trim(),
        password,
      });
      login(user);
      navigate('/');
    } catch (err) {
      if (err.response?.status === 422) {
        setError('Платформа уже настроена. Перейдите на страницу входа.');
      } else {
        setError('Ошибка при создании аккаунта. Попробуйте ещё раз.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="auth-theme"><ThemeToggle /></div>
      <div className="login-card">
        <div className="login-logo">
          <BrandMark />
          <h1 className="login-title">Agent R&amp;D Platform</h1>
        </div>
        <form onSubmit={handleSetup} className="login-form">
          <h2 className="login-form-title">Первоначальная настройка</h2>
          <p className="login-hint">Создайте аккаунт администратора для управления платформой.</p>
          <FormField label={<>Email</>}>
          <input className="form-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@example.com" autoFocus required />
          </FormField>
          <FormField label={<>Имя</>}>
          <input className="form-input" type="text" value={displayName} onChange={e => setDisplayName(e.target.value)} placeholder="Иван Иванов" required />
          </FormField>
          <FormField label={<>Пароль</>}>
          <input className="form-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Минимум 6 символов" required />
          </FormField>
          <FormField label={<>Подтверждение пароля</>}>
          <input className="form-input" type="password" value={passwordConfirm} onChange={e => setPasswordConfirm(e.target.value)} placeholder="Повторите пароль" required />
          </FormField>
          {error && <div className="login-error">{error}</div>}
          <Button className="btn btn-primary login-btn" type="submit" disabled={loading}>
            {loading ? 'Создание...' : 'Создать аккаунт администратора'}
          </Button>
        </form>
      </div>
    </div>
  );
}
